import styled, { css } from 'styled-components';
import { clearButtonStyles } from '../../base/utils';
import { slideCenterLeft, slideCenterRight } from '../../base/keyframes/slides';
import RspImageBg from '../../base/images/rspImageBg';

const carouselButtonStyles = css`
	position: absolute;
	top: 0; bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
	padding: 0 2rem;
	color: #fff;
	opacity: 0;
	transition: transform 250ms ease, opacity 250ms ease;
	cursor: pointer;
	pointer-events: none;

	svg {
		height: 2.4rem;
		width: 2.4rem;
		transition: transform 200ms ease;
	}

	&:hover {
		svg {
			transform: scale(1.2);
		}
	}
`;

export const CarouselLeft = styled.button`
	${clearButtonStyles};
	${carouselButtonStyles};
	left: 0;
	transform: translate3d(-100%, 0, 0);
`;

export const CarouselRight = styled.button`
	${clearButtonStyles};
	${carouselButtonStyles};
	right: 0;
	transform: translate3d(100%, 0, 0);
`;

export const Dots = styled.div`
	display: flex;
	justify-content: center;
	position: absolute;
	left: 0;
	bottom: 1.5rem;
	width: 100%;
	opacity: 0;
	transition: opacity 350ms ease;
	pointer-events: none;
`;

export const Dot = styled.div`
	padding: 1.5rem 0.5rem;
	cursor: pointer;

	&:first-child:after { padding-left: 0; }
	&:last-child:after { padding-right: 0; }

	&:after {
		content: '';
		display: block;
		width: 1.1rem;
		height: 1.1rem;
		background-color: #fff;
		opacity: 0.5;
		transition: opacity 250ms ease, transform 200ms ease;
		border-radius: 100%;
	}

	&:hover:after {
		opacity: 0.8;
		transform: scale(1.1);
	}

	${({ active }) => active && css`
		&:after {
			opacity: 1;
		}
	`}
`;

export const Animation = styled.div`
	display: none;
	position: absolute;
	top: 0; right: 0;
	bottom: 0; left: 0;
	background-color: ${({ theme }) => theme.colors.primaryLight};

	${({ direction }) => direction === 'left' && css`
		transform: translate3d(100%, 0, 0);
		animation: ${slideCenterLeft} 500ms ease;
	`}

	${({ direction }) => direction === 'right' && css`
		transform: translate3d(100%, 0, 0);
		animation: ${slideCenterRight} 500ms ease;
	`}

	${({ active }) => active && css`
		display: block;
	`}
`;

export const Wrapper = styled(RspImageBg)`
	position: relative;
	padding-top: 75%;
	background-size: cover;
	background-position: 50% 50%;
	overflow: hidden;

	&:hover {
		${CarouselLeft}, ${CarouselRight}, ${Dots} {
			transform: translate3d(0, 0, 0);
			opacity: 1;
			pointer-events: all;
		}
	}
`;
